export function initSummaryPage() {
    // attach event listners to the confirmation buttons

  
    
    document.addEventListener("sds-confirm", (e) => handleNotificationButtonClick(e, "confirm"));
    document.addEventListener("sds-dismiss", (e) => handleNotificationButtonClick(e, "dismiss"));
}

function handleNotificationButtonClick(e, targetType){
    const confirmTarget = e.srcElement.dataset.confirmTarget;
    const dismissTarget = e.srcElement.dataset.dismissTarget;
    
    const target = targetType === "confirm" ? confirmTarget : dismissTarget;
    if(target) window.location.href = target;
    e.preventDefault(); 
}